import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import Measure from 'react-measure';
import { s as styleInject } from './style-inject.es-746bb8ed.js';

var css_248z$1 = ".glob_fontElementMap,.r5C5w{font-family:var(--ricos-font-family,unset)}.Rmr2U{font-family:var(--ricos-settings-text-font-family,HelveticaNeue,Helvetica,Arial);max-width:calc(100% - 10px);min-height:50px;outline:0;position:absolute;top:var(--offset-top);transition:transform .15s cubic-bezier(.3,1.2,.2,1);z-index:4}[dir] .Rmr2U{background:#fff;border:1px solid #ddd;border-radius:6px;transform:scale(0)}[dir=ltr] .Rmr2U{direction:ltr;left:var(--offset-left);margin-left:10px}[dir=rtl] .Rmr2U{direction:rtl;margin-right:10px;right:var(--offset-left)}.Rmr2U._4mTeg{max-width:unset}.M5jIG{display:flex;height:48px}[dir] .M5jIG{padding:0 19px}.M5jIG::-webkit-scrollbar{display:none;width:0!important}.M5jIG button:focus{outline:5px auto Highlight!important;outline:5px auto -webkit-focus-ring-color!important}.XHdFu{display:flex;justify-content:center}[dir] .XHdFu{margin-top:-8px}[dir] .owru2{border-top:1px solid hsla(0,0%,46%,.2);padding:0 24px}.sgNai{height:auto}[dir] .sgNai{padding:0}.FlFOh{display:none;flex:0 0 24px}.AIHXM{flex:0 0 40px;height:100%}[dir] .AIHXM{background:transparent;border:none;cursor:pointer}[dir=ltr] .AIHXM{border-left:1px solid #ededed;margin-right:-19px}[dir=rtl] .AIHXM{border-right:1px solid #ededed;margin-left:-19px}.AIHXM>i{display:inline-block;height:6px;width:6px}[dir] .AIHXM>i{border:1px solid var(--ricos-settings-text-color,#333)}[dir=ltr] .AIHXM>i{border-width:0 0 1px 1px}[dir=rtl] .AIHXM>i{border-width:0 1px 1px 0}[dir=ltr] .IUi5P{border-left:1px solid #ededed;border-radius:0 6px 6px 0;right:0}[dir=rtl] .IUi5P{border-radius:6px 0 0 6px;border-right:1px solid #ededed;left:0}[dir=ltr] .bZYc2{margin-right:3px;transform:rotate(45deg)}[dir=rtl] .bZYc2{margin-left:3px;transform:rotate(-45deg)}[dir=ltr] .TZdQ5{border-left:1px solid #ededed;border-radius:0 6px 6px 0;right:0}[dir=rtl] .TZdQ5{border-radius:6px 0 0 6px;border-right:1px solid #ededed;left:0}[dir=ltr] ._6sJDy{margin-right:3px;transform:rotate(225deg)}[dir=rtl] ._6sJDy{margin-left:3px;transform:rotate(-225deg)}@media only screen and (max-width:640px){[data-query=media] .M5jIG{-webkit-overflow-scrolling:auto;display:flex;max-width:100%;overflow-x:scroll;scroll-behavior:smooth;width:auto}[data-query=media] .M5jIG .FlFOh{display:block}[data-query=media] .M5jIG .AIHXM{display:block}}@supports not (contain:inline-size){@media only screen and (max-width:640px){[data-query=container] .M5jIG{-webkit-overflow-scrolling:auto;display:flex;max-width:100%;overflow-x:scroll;scroll-behavior:smooth;width:auto}[data-query=container] .M5jIG .FlFOh{display:block}[data-query=container] .M5jIG .AIHXM{display:block}}}@container (width < 640px){[data-query=container] .M5jIG{-webkit-overflow-scrolling:auto;display:flex;max-width:100%;overflow-x:scroll;scroll-behavior:smooth;width:auto}[data-query=container] .M5jIG .FlFOh{display:block}[data-query=container] .M5jIG .AIHXM{display:block}}._7-A9s{-webkit-overflow-scrolling:auto;align-items:center;display:flex;height:auto;overflow:hidden;pointer-events:none;scroll-behavior:smooth;width:100%}[dir] ._7-A9s{margin:-90px 0;padding:90px 0}._7-A9s>*{pointer-events:auto}._7-A9s::-webkit-scrollbar{display:none;width:0!important}";
var toolbarStyles = {"fontElementMap":"r5C5w","pluginToolbar":"Rmr2U","overflowToolbar":"_4mTeg","pluginToolbar_buttons":"M5jIG","pluginToolbar_panel":"XHdFu","pluginToolbar_inlinePanel":"owru2","pluginToolbar_overrideContent":"sgNai","pluginToolbar_responsiveSpacer":"FlFOh","pluginToolbar_responsiveArrow":"AIHXM","pluginToolbar_responsiveArrowStart":"IUi5P","pluginToolbar_responsiveArrowStart_icon":"bZYc2","pluginToolbar_responsiveArrowEnd":"TZdQ5","pluginToolbar_responsiveArrowEnd_icon":"_6sJDy","pluginToolbar_scrollableContainer":"_7-A9s"};
styleInject(css_248z$1);

var css_248z = ".Ji5St,.glob_fontElementMap{font-family:var(--ricos-font-family,unset)}.qHbM2{color:var(--ricos-settings-text-color,#333);display:flex;font-family:var(--ricos-settings-text-font-family,HelveticaNeue,Helvetica,Arial)}[dir] .qHbM2{padding:10px 0}[dir=ltr] .qHbM2{margin-right:10px}[dir=rtl] .qHbM2{margin-left:10px}[dir=ltr] .qHbM2:last-child{margin-right:0}[dir=rtl] .qHbM2:last-child{margin-left:0}[dir] .qHbM2:hover .YPskX:not(.zqWqs):not(._7jwGJ){background-color:rgba(var(--ricos-settings-action-color-tuple,var(--ricos-fallback-color-tuple,0,0,0)),.06)}.qHbM2 ._7jwGJ{fill:var(--ricos-settings-action-color,var(--ricos-action-color-fallback,#0261ff));color:var(--ricos-settings-action-color,var(--ricos-action-color-fallback,#0261ff))}[dir] .qHbM2 ._7jwGJ{background-color:rgba(var(--ricos-settings-action-color-tuple,var(--ricos-action-color-fallback-tuple,2,97,255)),.1)}.YPskX{color:var(--ricos-settings-text-color,#333);display:inline-block;line-height:normal;white-space:nowrap}[dir] .YPskX{background:transparent;border:none;border-radius:var(--ricos-settings-small-buttons-border-radius,unset);cursor:pointer;margin:0;padding:5px}.YPskX .yrozA{height:20px;line-height:0;width:20px}.YPskX .yrozA svg{height:100%;width:100%}.YPskX:not(._7jwGJ) svg{fill:var(--ricos-settings-icons-color,currentColor);color:var(--ricos-settings-icons-color,currentColor)}.YPskX:not(.zqWqs)._7jwGJ{fill:var(--ricos-settings-action-color,var(--ricos-action-color-fallback,#0261ff));color:var(--ricos-settings-action-color,var(--ricos-action-color-fallback,#0261ff))}.YPskX.zqWqs{opacity:.4}[dir] .YPskX.zqWqs{cursor:default}";
var buttonStyles = {"fontElementMap":"Ji5St","pluginToolbarButton_wrapper":"qHbM2","pluginToolbarButton":"YPskX","pluginToolbarButton_disabled":"zqWqs","pluginToolbarButton_active":"_7jwGJ","pluginToolbarButton_icon":"yrozA"};
styleInject(css_248z);

var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __publicField = (obj, key, value) => {
  __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
  return value;
};
class ToolbarContent extends PureComponent {
  constructor(props) {
    super(props);
    __publicField(this, "setToolbarScrollButton", (scrollLeft, scrollWidth, clientWidth) => {
      const currentScrollButtonWidth = this.state.showLeftArrow || this.state.showRightArrow ? 20 : 0;
      const isScroll = scrollWidth - clientWidth - currentScrollButtonWidth > 8;
      this.setState({
        showLeftArrow: isScroll && scrollLeft === scrollWidth - clientWidth,
        showRightArrow: isScroll && scrollLeft < scrollWidth - clientWidth
      });
    });
    this.state = { showLeftArrow: false, showRightArrow: false };
  }
  scrollToolbar(event, leftDirection) {
    event.preventDefault();
    const { clientWidth, scrollWidth } = this.scrollContainer;
    this.scrollContainer.scrollLeft = leftDirection ? 0 : Math.min(this.scrollContainer.scrollLeft + clientWidth, scrollWidth);
  }
  componentDidMount() {
    var _a, _b;
    (_b = (_a = this.props).triggerOnLoadBi) == null ? void 0 : _b.call(_a);
  }
  render() {
    const { showLeftArrow, showRightArrow } = this.state;
    const {
      overrideContent: OverrideContent,
      tabIndex,
      theme,
      PluginToolbarButton,
      structure,
      onOverrideContent,
      componentData
    } = this.props;
    const hasArrow = showLeftArrow || showRightArrow;
    const { toolbarStyles: toolbarTheme } = theme || {};
    const { buttonStyles: buttonTheme, separatorStyles: separatorTheme } = theme || {};
    const scrollableContainerClasses = classNames(
      toolbarStyles.pluginToolbar_scrollableContainer,
      toolbarTheme && toolbarTheme.pluginToolbar_scrollableContainer
    );
    const buttonContainerClassnames = classNames(
      toolbarStyles.pluginToolbar_buttons,
      toolbarTheme && toolbarTheme.pluginToolbar_buttons,
      {
        [toolbarStyles.pluginToolbar_overrideContent]: !!OverrideContent,
        [toolbarTheme.pluginToolbar_overrideContent]: !!OverrideContent
      }
    );
    const themedButtonStyle = __spreadValues({
      buttonWrapper: classNames(
        buttonStyles.pluginToolbarButton_wrapper,
        buttonTheme && buttonTheme.pluginToolbarButton_wrapper
      ),
      button: classNames(
        buttonStyles.pluginToolbarButton,
        buttonTheme && buttonTheme.pluginToolbarButton
      ),
      icon: classNames(
        buttonStyles.pluginToolbarButton_icon,
        buttonTheme && buttonTheme.pluginToolbarButton_icon
      ),
      active: classNames(
        buttonStyles.pluginToolbarButton_active,
        buttonTheme && buttonTheme.pluginToolbarButton_active
      ),
      disabled: classNames(
        buttonStyles.pluginToolbarButton_disabled,
        buttonTheme && buttonTheme.pluginToolbarButton_disabled
      )
    }, theme);
    const arrowClassNames = classNames(
      toolbarStyles.pluginToolbar_responsiveArrow,
      toolbarTheme && toolbarTheme.pluginToolbar_responsiveArrow
    );
    const leftArrowIconClassNames = classNames(
      toolbarStyles.pluginToolbar_responsiveArrowStart_icon,
      toolbarTheme && toolbarTheme.responsiveArrowStart_icon
    );
    const rightArrowIconClassNames = classNames(
      toolbarStyles.pluginToolbar_responsiveArrowEnd_icon,
      toolbarTheme && toolbarTheme.responsiveArrowEnd_icon
    );
    const separatorClassNames = classNames(
      toolbarStyles.pluginToolbarSeparator,
      separatorTheme && separatorTheme.pluginToolbarSeparator
    );
    const overrideProps = { onOverrideContent };
    return /* @__PURE__ */ React.createElement("div", { className: buttonContainerClassnames }, /* @__PURE__ */ React.createElement(
      Measure,
      {
        client: true,
        scroll: true,
        innerRef: (ref) => this.scrollContainer = ref,
        onResize: ({ scroll, client }) => this.setToolbarScrollButton(scroll.left, scroll.width, client.width)
      },
      ({ measure, measureRef }) => /* @__PURE__ */ React.createElement("div", { className: scrollableContainerClasses, ref: measureRef, onScroll: () => measure() }, OverrideContent ? /* @__PURE__ */ React.createElement(OverrideContent, __spreadValues({}, overrideProps)) : structure.map((button, index) => /* @__PURE__ */ React.createElement(
        PluginToolbarButton,
        {
          button,
          key: index,
          themedStyle: themedButtonStyle,
          separatorClassNames,
          tabIndex,
          index,
          componentData
        }
      )))
    ), hasArrow && /* @__PURE__ */ React.createElement(
      "button",
      {
        tabIndex,
        className: arrowClassNames,
        "data-hook": "pluginToolbarRightArrow",
        onMouseDown: (e) => this.scrollToolbar(e, showLeftArrow)
      },
      /* @__PURE__ */ React.createElement("i", { className: showLeftArrow ? leftArrowIconClassNames : rightArrowIconClassNames })
    ));
  }
}
__publicField(ToolbarContent, "propTypes", {
  overrideContent: PropTypes.any,
  tabIndex: PropTypes.number,
  theme: PropTypes.object,
  PluginToolbarButton: PropTypes.elementType,
  structure: PropTypes.object,
  onOverrideContent: PropTypes.func,
  componentData: PropTypes.object,
  triggerOnLoadBi: PropTypes.func
});

export { ToolbarContent as T, toolbarStyles as t };
//# sourceMappingURL=ToolbarContent-5f9b4523.js.map
